import React from "react";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toEditSubSegProps, subSegError } from "../../../../utils/types";
import { AxiosError } from "axios";
import { api, getToken } from "../../../../services/apis/auth-api/apiUrl";

interface checkButtonProps {
    id : number,
    onLoad : (id : number, loadRes : boolean) => void;
    toUpdate : toEditSubSegProps[],
    endPoint : string,
    method : string,
    onSubmitStat :  (id : number , error: subSegError) => void;
    onUpdated : (id : number, name : string) => void;
}

const CheckButton : React.FC<checkButtonProps> = ({id, onLoad, toUpdate, endPoint, method, onSubmitStat, onUpdated}) => {
    
    function submitRequest (){
        let name = '';
        
        toUpdate.map((item)=> 
            item.id === id ? name = item.sub_segment_name : '')

        if(name === '') return false;

        onLoad(id, true);
        setTimeout(async()=>{
            try{
                await api({
                    method : method,
                    url : endPoint+id,
                    data : {name : name},
                    headers : {'Authorization' : 'Bearer '+getToken()}
                })
                onUpdated(id, name);
            }catch(e){
                const error = (e as AxiosError);
                if(error.response?.status === 401){
                    onSubmitStat(id, {error : true, msg : 'Unauthorized access!'});
                }else{
                    onSubmitStat(id, {error : true, msg : 'An error occured!'});
                }
            }
        },1000)
    }

    return (
        <i onClick={submitRequest} className="cursor-pointer text-green-600">
            <FontAwesomeIcon icon={faCheck} />
        </i>
    );
}

export default CheckButton